import { render } from "./CategoryArea.vue?vue&type=template&id=1feb802c"
import script from "./CategoryArea.vue?vue&type=script&lang=js"
export * from "./CategoryArea.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gabrielalencar/Documents/custom/gestio-school-frontend-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__